import React  from 'react'
import DropDown from '../dropdown';
import { GetCurrency } from '../../../api/services/finance';

const CurrencyDropDown = (props) => {
    return <DropDown api={GetCurrency} search textField="Code" valueField="Id" {...props} />
}

export default CurrencyDropDown
